<template>
  <div>
    <div class="card bg-white rounded">
      <vs-row>
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="12">
          <feather-icon
            class="mr-4"
            icon="BookIcon"
            svgClasses="text-black stroke-current w-36.96 h-36.96"
          ></feather-icon>
          <h1 class="md:lg m-0">Formação</h1>
        </vs-col>

        <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="12">
          <span class="my-2 md:text-base"
            >Nós precisamos saber mais sobre o que você estuda ou já estudou.
            Vamos nessa? Clique no botão abaixo para adicionar suas
            formações!</span
          >
        </vs-col>

        <vs-col vs-w="12">
          <vs-button
            @click="goToSaveFormation(null)"
            icon="add"
            color="primary"
            type="border"
            class="mb-3"
          >
            Adicionar Formação
          </vs-button>
        </vs-col>
        <vs-col vs-w="12" class="mb-10">
          <vs-button
            class="my-5 mb-2"
            icon="star"
            color="#7d33ff"
            type="border"
            @click="generateFormationsFromCV()"
          >
            Criar Formações a partir do CV
          </vs-button>
          <small>Utilizamos Inteligência Artificial para analisar os dados do arquivo de Currículo. <br>Analise e revise o resultado, e faça as edições que achar necessárias principalmente nas datas.</small>
        </vs-col>

        <vs-col
          class="mb-1"
          vs-w="12"
          v-for="(item, index) in formations"
          :key="`formation-card-${index}`"
        >
          <div class="vertical-bar" :style="{ borderColor: color }">
            <vs-row>
              <vs-col vs-w="12" vs-type="flex" vs-justify="space-between">
                <vs-row>
                  <vs-col vs-w="12">
                    <b
                      ><p class="mb-1">
                        {{ instituteAndScholarity(item) }}
                      </p></b
                    >
                    <p class="mb-1">
                      {{ gradeAndLevel(item) }}
                    </p>
                    <p class="mb-1">
                      {{ fromAndTo(item) }}
                    </p>
                  </vs-col>
                </vs-row>
                <div class="flex">
                  <vs-button
                    size="small"
                    radius
                    color="primary"
                    type="border"
                    icon="edit"
                    @click="goToSaveFormation(item)"
                    class="mr-2"
                  />
                  <vs-button
                    size="small"
                    radius
                    color="primary"
                    type="border"
                    icon="delete"
                    @click="handleRemovePopupActive(item)"
                  />
                </div>
              </vs-col>
            </vs-row>
          </div>
        </vs-col>
        <div class="flex flex-wrap w-full mt-2">
          <backward-button @click="handleBackward" />
          <forward-button @click="handleForward" />
        </div>
      </vs-row>
    </div>

    <vs-popup title="Remover Formação" :active.sync="removePopupActive">
      <vs-row>
        <vs-col
          class="mb-8"
          vs-type="flex"
          vs-align="center"
          vs-justify="start"
          vs-w="12"
        >
          <p>Deseja Remover a formação?</p>
        </vs-col>

        <vs-col
          class="px-0 flex-row-reverse"
          vs-type="flex"
          vs-align="center"
          vs-justify="end"
          vs-w="12"
        >
          <vs-button
            class="mx-1"
            @click="handleRemoveFormation"
            color="danger"
            type="filled"
          >
            Remover
          </vs-button>
          <vs-button
            class="mx-1"
            @click="removePopupActive = false"
            color="dark"
            type="flat"
          >
            Cancelar
          </vs-button>
        </vs-col>
      </vs-row>
    </vs-popup>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import BackwardButton from "@/components/BackwardButton";
import ForwardButton from "@/components/ForwardButton";
import { isBefore } from "date-fns";
import vSelect from "vue-select";

export default {
  data: () => ({
    formationToRemove: {},
    removePopupActive: false,
  }),
  computed: {
    ...mapState("auth", ["auth"]),
    ...mapState("formation", ["higherEducation", "formation"]),
    ...mapGetters("formation", ["formations"]),
    ...mapState("company", ["company"]),

    color() {
      return this.company.base_hexcolor || "#1551b1";
    },
  },
  created() {
    this.$validator.extend(
      "compareDate",
      {
        getMessage: (field, params, data) =>
          (data && data.message) || "Verifique as datas de início e saída",
        validate: (value, [otherValue]) => {
          return new Promise((resolve) => {
            if (otherValue == "")
              resolve({
                valid: false,
                data: { message: "A data de início está vazia!" },
              });

            const splitFrom = "01/".concat(otherValue).split("/");
            const splitTo = "01/".concat(value).split("/");

            const monthReg = /0[1-9]|1[0-2]/;
            const yearReg = /(?:(?:19|20)[0-9]{2})/;

            if (!splitFrom[1].match(monthReg))
              resolve({
                valid: false,
                data: {
                  message: `O mês ${splitFrom[1]} informado na data de início não é válido!`,
                },
              });
            if (!splitTo[1].match(monthReg))
              resolve({
                valid: false,
                data: {
                  message: `O mês ${splitTo[1]} informado não é válido!`,
                },
              });

            if (!splitFrom[2].match(yearReg))
              resolve({
                valid: false,
                data: {
                  message: `O ano ${splitFrom[2]} informado na data de início não é válido!`,
                },
              });
            if (!splitTo[2].match(yearReg))
              resolve({
                valid: false,
                data: {
                  message: `O ano ${splitTo[2]} informado não é válido!`,
                },
              });

            const from = new Date(splitFrom[2], splitFrom[1] - 1, splitFrom[0]);
            const to = new Date(splitTo[2], splitTo[1] - 1, splitTo[0]);

            resolve({
              valid: isBefore(from, to),
              data: {
                message: `${
                  isBefore(from, to)
                    ? ""
                    : "A data de finalização não pode ser menor que a data de início"
                }`,
              },
            });
          });
        },
      },
      { hasTarget: true, immediate: false }
    );

    this.fetchFormations();
    window.scroll(0, 0);
  },
  methods: {
    handleBackward() {
      if (this.onEditMode()) {
        this.$router.push({
          name: "dashboard-profile-detail",
        });
        return;
      }

      this.$store.dispatch("step/decrementCurrentStep");
      const step = this.$store.getters["step/current"];

      const { params } = this.$router.history.current;

      this.$router.push({
        name: step.path,
        params,
      });
    },

    async handleForward() {
      if (this.onEditMode()) {
        this.$router.push({
          name: "dashboard-profile-detail",
        });
        return;
      }
      await this.$store.dispatch("step/completeStep");

      await this.$store.dispatch("step/incrementCurrentStep");

      const step = this.$store.getters["step/current"];

      const { params } = this.$router.history.current;

      this.$router.push({
        name: step.path,
        params,
      });
    },

    onEditMode() {
      const currentPath = this.$router.history.current.name;
      return currentPath.slice(0, 4) == "edit";
    },

    fetchFormations() {
      this.$vs.loading();

      const { company_label } = this.$router.history.current.params;

      this.$http
        .get(`api/v1/talent/${company_label}/user/talent?step=formations`)
        .then((response) => {
          this.$vs.loading.close();

          const { formations } = response.data.data;

          this.$store.dispatch("formation/index", formations);
        })
        .catch((error) => {
          this.$vs.loading.close();
        });
    },

    generateFormationsFromCV(){
      this.$vs.loading({
        text: "Aguarde! Lendo CV e analisando experiências...",
      });

      const timeout = 45000; // 45 segundos (45.000 milissegundos)
      let isTimeout = false;

      // Configurar o temporizador de timeout
      const timeoutHandler = setTimeout(() => {
        isTimeout = true;
        this.$vs.loading.close();
        this.$vs.notify({
          title: "Tempo limite excedido",
          text: "Tente novamente mais tarde.",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
        });
        this.fetchExperiences();
      }, timeout);

      const payload = {
        feature: 'talent_curriculum_content_generate',
        feature_data: {
          talent_id: this.auth.user.talent.id,
          data_type: "formations"
        }
      };
      this.$http.post('/api/v2/assistant/chat', payload)
      .then(response => {

        if (!isTimeout) {
          clearTimeout(timeoutHandler); // Limpa o temporizador se a resposta chegou a temp

          this.$vs.loading.close();
          if(response.data.answer !== null){
            window.woopra.track("generate-formations-clicked", {
              'formations' : response.data.answer
            });
            this.fetchFormations();
          }else{
            this.$vs.notify({
              title: "Não foi possível obter os dados de formações",
              text:
                "Tente novamente em alguns instantes, estamos processando o CV. Caso persista, o formato de CV não foi lido corretamente.",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "warning",
            });  
          }
        }
      })
      .catch(error => {
        this.$vs.loading.close();
        console.log(error);
        clearTimeout(timeoutHandler); // Limpa o temporizador se a resposta chegou a temp
        this.$vs.notify({
          title: "Não foi possível obter os dados de formações",
          text:
            "Tente novamente em alguns instantes, estamos processando o CV. Caso persista, o formato de CV não foi lido corretamente.",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
        });
      });
    },

    goToSaveFormation(formation) {
      if (!formation) {
        this.$router.push({
          name: "formation-save",
          params: {
            formation,
          },
        });
        return;
      }

      this.$router.push({
        name: "formation-save",
        params: {
          formation,
        },
      });
    },

    handleEditPopupActive(formation) {
      this.payload = { ...formation };
      this.editPopupActive = true;
    },

    handleRemovePopupActive(formation) {
      this.formationToRemove = { ...formation };
      this.removePopupActive = true;
    },

    handleRemoveFormation() {
      this.$vs.loading({
        text: "Removendo...",
      });

      this.$http
        .delete(`api/v1/talents-formations/${this.formationToRemove.id}`)
        .then(async () => {
          this.$vs.loading.close();

          await this.$store.dispatch("formation/delete", {
            ...this.formationToRemove,
          });

          this.removePopupActive = false;
          this.formationToRemove = {};

          this.calculateProgress({
            field: "formation",
            value: this.formations,
          });
        })
        .catch(async () => {
          this.$vs.loading.close();
          this.removePopupActive = false;
        });
    },

    handleEditFormation() {
      this.$vs.loading({
        text: "Salvando...",
      });

      this.editPopupActive = false;

      const { company_label } = this.$router.history.current.params;

      if (!this.payload.grade) this.payload.grade = "";

      this.$http
        .post(`api/v1/talent/${company_label}/user/talent?step=formations`, {
          formations: [
            {
              ...this.payload,
            },
          ],
        })
        .then(() => {
          this.$vs.loading.close();

          this.$store.dispatch("formation/update", {
            ...this.payload,
          });

          this.payload = {
            index: 0,
            popupActive: false,
            scholarity: "",
            institute: "",
            level: "",
            grade: "",
            to_date: "",
            from_date: "",
          };
        })
        .catch(() => {
          this.$vs.loading.close();
        });
    },

    handleSaveFormation() {
      this.$vs.loading({
        text: "Salvando...",
      });

      this.popupActive = false;

      const { company_label } = this.$router.history.current.params;

      if (!this.payload.grade) this.payload.grade = "";

      this.$http
        .post(`api/v1/talent/${company_label}/user/talent?step=formations`, {
          formations: [
            {
              ...this.payload,
            },
          ],
        })
        .then((response) => {
          this.$vs.loading.close();

          const { formations } = response.data.data;

          this.$store.dispatch("formation/store", {
            ...this.payload,
            id: formations[0].id,
            index: formations[0].index,
          });

          this.payload = {
            index: 0,
            popupActive: false,
            scholarity: "",
            institute: "",
            level: "",
            grade: "",
            to_date: "",
            from_date: "",
          };

          this.calculateProgress({
            field: "formation",
            value: this.formations,
          });
        })
        .catch(() => {
          this.$vs.loading.close();
        });
    },

    instituteAndScholarity({ institute, scholarity }) {
      if (
        institute !== undefined &&
        institute !== null &&
        scholarity !== undefined &&
        scholarity !== null
      ) {
        return institute.concat(` - ${scholarity}`);
      }

      if (
        institute !== undefined &&
        institute !== null &&
        (scholarity === undefined || scholarity === null)
      ) {
        return institute;
      }

      if (
        (institute === undefined || institute === null) &&
        scholarity !== undefined &&
        scholarity !== null
      ) {
        return scholarity;
      }
    },

    gradeAndLevel({ grade, level }) {
      if (
        grade !== undefined &&
        grade !== null &&
        level !== undefined &&
        level !== null
      ) {
        return grade.concat(` - ${level}`);
      }

      if (
        grade !== undefined &&
        grade !== null &&
        (level === undefined || level === null)
      ) {
        return grade;
      }

      if (
        (grade === undefined || grade === null) &&
        level !== undefined &&
        level !== null
      ) {
        return level;
      }
    },

    fromAndTo({ from_date, to_date, level }) {
      if (
        from_date !== null &&
        from_date !== undefined &&
        to_date !== null &&
        to_date !== undefined
      ) {
        return `Período: `
          .concat(`${from_date}`)
          .concat(
            `${
              level !== " Em andamento " ? " até " : " previsão de formação em "
            }`
          )
          .concat(`${to_date}`);
      }
    },

    ...mapActions("progress", ["calculateProgress"]),
  },
  components: {
    BackwardButton,
    ForwardButton,
    VuePerfectScrollbar,
    "v-select": vSelect,
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/talent/views/steps/step.scss";
</style>
